<template>
  <section>
    <section class="calc-box-container">
      <!-- 左侧 -->
      <div class="calc-box-left">
        <div class="text-box f-dir-c ai-center">
          <div class="label">
            {{
            (dispatchInfo.appointWay === 3 &&
            dispatchInfo.vehicleClass !== 1) ||
            dispatchInfo.appointWay === 5
            ? '外调车运费'
            : '承包价'
            }}
          </div>
          <div class="value">
            <input
              class="calc-chart-ipt"
              type="text"
              v-model="dispatchInfo.totalFee"
              @blur="totalFeeChange()"
            />
          </div>
        </div>
        <div
          class="text-box f-dir-c ai-center"
          v-if="
            (dispatchInfo.appointWay === 3 &&
              dispatchInfo.vehicleClass !== 1) ||
            dispatchInfo.appointWay === 5
          "
        >
          <div class="label">运费上限</div>
          <div class="value">{{ dispatchInfo.guidePrice ? dispatchInfo.guidePrice : 0 }}</div>
        </div>
      </div>
      <!-- 间隔线 -->
      <div class="calc-box-separate"></div>
      <!-- 右侧 -->
      <div class="calc-box-right">
        <div class="row-title">
          <span>
            预付总计（标准{{
            ((dispatchInfo.preTotalScaleStandard)).toFixed(2)*100
            }}%）
          </span>
          <span>
            预付现金（标准{{
            ((dispatchInfo.preCashScaleStandard)).toFixed(2)*100
            }}%）
          </span>
          <span>
            预付油卡（标准{{
            ((dispatchInfo.preOilVirtualScaleStandard)).toFixed(2)*100
            }}%）
          </span>
          <span
            v-if="
              dispatchInfo.preEtcFee > 0 ||
              (dispatchInfo.appointWay === 3 &&
                dispatchInfo.vehicleClass === 1 &&
                dispatchInfo.paymentWay === 3)
            "
          >
            ETC（标准{{
            ((dispatchInfo.preEtcScaleStandard)).toFixed(2)*100
            }}%）
          </span>
        </div>
        <div class="calc-row">
          <div class="row-label">预付金额</div>
          <div class="row-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preTotalFee"
                    readonly
                  />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preTotalScale"
                    readonly
                  />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">=</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preCashFee"
                    @blur="feeUpdate('CASH')"
                  />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preCashScale"
                    @blur="scaleUpdate('CASH')"
                  />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">虚拟油</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preOilVirtualFee"
                    @blur="feeUpdate('VIRTUAL')"
                  />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preOilVirtualScale"
                    @blur="scaleUpdate('VIRTUAL')"
                  />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">实体油</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preOilFee"
                    @blur="feeUpdate('OIL')"
                  />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.preOilScale"
                    @blur="scaleUpdate('OIL')"
                  />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <template
              v-if="
                dispatchInfo.preEtcFee > 0 ||
                (dispatchInfo.appointWay === 3 &&
                  dispatchInfo.vehicleClass === 1 &&
                  dispatchInfo.paymentWay === 3)
              "
            >
              <div class="row-symbol">+</div>
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label">金额</div>
                  <div class="value">
                    <input
                      class="calc-chart-ipt"
                      type="text"
                      v-model="dispatchInfo.preEtcFee"
                      @blur="feeUpdate('ETC')"
                    />
                  </div>
                </div>
                <div class="text-box ai-center">
                  <div class="label">比例</div>
                  <div class="value">
                    <input
                      class="calc-chart-ipt"
                      type="text"
                      v-model="dispatchInfo.preEtcScale"
                      @blur="scaleUpdate('ETC')"
                    />
                    <span class="calc-chart-unit">%</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="calc-row">
          <div class="row-label">到付金额</div>
          <div class="row-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.arrivePaymentFee"
                    @blur="feeUpdate('ARRIVE_CASH')"
                  />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.arrivePaymentFeeScale"
                    @blur="scaleUpdate('ARRIVE_CASH')"
                  />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-row">
          <div class="row-label">尾款金额</div>
          <div class="row-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.finalFee"
                    readonly
                  />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.finalScale"
                    readonly
                  />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">=</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">现金</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.finalCashFee"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">保费</div>
                <div class="value">
                  <input
                    class="calc-chart-ipt"
                    type="text"
                    v-model="dispatchInfo.insuranceFee"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="125px"
    ></qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </section>
</template>

<script>
import {
  getLevel,
  getAmountLimitCfgVal,
} from 'api/operate';
import {
  isExist,
  isTwoBitDecimal,
} from '@qx/utils/index';
import {mapState} from 'vuex';
export default {
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    isNeedBill: {
      type: Number,
      default: 0,
    },
    paymentWay: {
      type: Number,
      default: 0,
    },
    appointWay: {
      type: Number,
      default: 3,
    },
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '分配油来源',
            value: 'oilAccountType',
            type: 'select',
            default: '1',
            options: [
              { label: '本车队定点油', value: '1' },
              { label: '找油-无发票', value: '2' },
              { label: '找油-有发票', value: '3' },
            ],
            hide: true,
            onChange: (val) => {
              this.oilAccountTypeChange();
            },
          },
          {
            label: '司机是否可见工资',
            value: 'showWagesFlg',
            type: 'radio',
            default: 0,
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
          },
          {
            label: '税点及操作费用',
            value: 'taxPoint',
            type: 'input',
            unit: '%',
            default: '7',
            hide: true,
          },
          {
            label: '其他费用',
            value: 'otherFee',
            type: 'input',
            hide: true,
          },
        ],
      },
      // 会员权益
      LevelInfo: {},
      dispatchInfo: {
        isNeedBill: 0,
        appointWay: 3,
        paymentWay: 0,
        vehicleClass: 0,
        totalFee: 0,
        guidePrice: 0,
        preTotalScaleStandard: 0,
        preCashScaleStandard: 0,
        preOilVirtualScaleStandard: 0,
        preEtcScaleStandard: 0,
        preTotalFee: 0,
        preTotalScale: 0,
        preCashFee: 0,
        preCashScale: 0,
        preOilVirtualFee: 0,
        preOilVirtualScale: 0,
        preOilFee: 0,
        preOilScale: 0,
        preEtcFee: 0,
        preEtcScale: 0,
        arrivePaymentFee: 0,
        arrivePaymentFeeScale: 0,
        finalFee: 0,
        finalScale: 0,
        finalCashFee: 0,
        insuranceFee: 0,
        maxAmount: 0,
        taxPoint: 0,
        otherFee: 0,
      },
      feeList: [],
      feeTitle: '',
    };
  },
  methods: {
    async getDataTest () {
      // console.log('承包模式参数', this.getFormsValue());
    },
    // 设置/回填所需参数
    setFormsValue (data) {
      this.setFormVal(this.dispatchInfo, data);
      if (isExist(this.dispatchInfo.oilAccountType)) {
        this.$refs.baseForm.setVal('oilAccountType', String(this.dispatchInfo.oilAccountType) || '1');
      }
    },
    // 获取会员权益
    async getVehicleClassLevel (vehicleClass, type) {
      this.dispatchInfo.vehicleClass = vehicleClass || 3;
      if (!this.dispatchInfo.vehicleClass) {
        return;
      }
      this.setOtherValue(type);
      this.LevelInfo = await getLevel({
        vehicleClass: this.dispatchInfo.vehicleClass,
      });

      this.setTotalFee(this.LevelInfo);

      // 下面不知道干嘛的
      if (this.dispatchInfo.vehicleClass !== null && this.dispatchInfo.vehicleClass !== 1) {
        this.setPreOilFee();
      }
      // if (this.dispatchInfo.isNeedBill === 0) {
      //   this.feeUpdate('VIRTUAL');
      // }
    },
    // 设置
    setOtherValue (type) {
      if (type === 'paymentWay') {
        this.dispatchInfo.totalFee = 0;
        this.feeTitle = '承包价';
      } else {
        // type 为 'setVehicleInfo' 时
        if (this.chartData && this.chartData.lineInfo) {
          this.dispatchInfo.guidePrice = isExist(this.chartData.lineInfo.guidePrice) ? Number(this.chartData.lineInfo.guidePrice) / 100 : 0;
          this.feeTitle = '外调车运费';
        }
      }

      if (this.chartData && this.chartData.lineInfo) {
        this.dispatchInfo.totalFee = isExist(this.chartData.lineInfo.guideMerchant) ? Number(this.chartData.lineInfo.guideMerchant) / 100 : 0;

        if (!isExist(this.chartData.lineInfo.guideMerchant) &&
          this.chartData.lineInfo.sourceId !== null &&
          this.chartData.lineInfo.sourceId > 0) {
          this.$message({
            type: 'warning',
            message: `本次开单的线路中没有设定运费标准，故${this.feeTitle}为0，请在线路档案中设定运费标准`,
          });
        }
      }
    },
    // 设置中标价 指导价 设置支付标准比例
    setTotalFee (data) {
      /* eslint-disable */
      // 保费集合
      this.feeList = data.feeList;
      // 初始化标准比例

      //【2022042501】车管处理遗留问题--此处不知道原来为什么注释掉，暂时不知道是否有问题，注释掉会影响流程，暂时先打开   --By liuanming
      // 预付总计上限比例标准
      this.dispatchInfo.preTotalScaleStandard = isExist(data.advanceCharge) ? data.advanceCharge : 0;
      // 预付虚拟油卡比例标准
      this.dispatchInfo.preOilVirtualScaleStandard = isExist(data.oilScale) ? data.oilScale : 0;
      // 预付油卡比例标准
      this.dispatchInfo.preOilScaleStandard = 0;
      // 预付ETC比例标准//预付ETC比例标准
      this.dispatchInfo.preEtcScaleStandard = isExist(data.etcScale) ? data.etcScale : 0;
      if (this.dispatchInfo.vehicleClass !== 1) {
        this.dispatchInfo.preEtcScaleStandard = 0;
      }
      // 预付现金比例标准
      this.dispatchInfo.preCashScaleStandard = this.dispatchInfo.preTotalScaleStandard - this.dispatchInfo.preOilVirtualScaleStandard - this.dispatchInfo.preEtcScaleStandard;

      // 初始化实际比例  比例显示：百分比 * 100
      // 预付总计上限比例值
      this.dispatchInfo.preTotalScale = this.dispatchInfo.preTotalScaleStandard * 100;

      // 初始化到付比例
      this.dispatchInfo.arrivePaymentFeeScale = 0;
      // 预付尾款比例值
      this.dispatchInfo.finalScale = 1 - this.dispatchInfo.preTotalScaleStandard;
      this.dispatchInfo.finalScale = Number((this.dispatchInfo.finalScale * 100).toFixed(2));

      // 预付现金比例 显示值 比例显示：百分比 * 100
      this.dispatchInfo.preCashScale = (this.dispatchInfo.preTotalScaleStandard - this.dispatchInfo.preOilVirtualScaleStandard - this.dispatchInfo.preEtcScaleStandard) * 100;
      // 预付虚拟油卡比例 显示值 比例显示：百分比 * 100
      this.dispatchInfo.preOilVirtualScale = this.dispatchInfo.preOilVirtualScaleStandard * 100;
      // 预付油卡比例  显示值 比例显示：百分比 * 100
      this.dispatchInfo.preOilScale = this.dispatchInfo.preOilScaleStandard * 100;
      // 预付ETC比例  显示值 比例显示：百分比 * 100
      this.dispatchInfo.preEtcScale = this.dispatchInfo.preEtcScaleStandard * 100;

      this.dispatchInfo.paymentDays = isExist(data.paymentDay) ? data.paymentDay : 0;

      if (JSON.stringify(data) === '{}') {
        this.dispatchInfo.guidePrice = 0;
      }

      // // 更改中标价/承包价
      // this.totalFeeChange();
    },
    setGuidePrice () {
      //司机和驻场的时候，要设置中标价 外调用原社会车指导价  自有车和招商车用以前招商车指导价
      if (isExist(this.dispatchInfo.vehicleClass)) {
        if (this.dispatchInfo.vehicleClass == 2) {   //招商车
          this.dispatchInfo.guidePrice = this.chartData.lineInfo.guideMerchant;
        } else if (this.dispatchInfo.vehicleClass == 1) {  //自有车
          if (this.dispatchInfo.paymentWay == 3) {
            this.dispatchInfo.guidePrice = this.chartData.lineInfo.guideMerchant;
          } else if (this.dispatchInfo.paymentWay == 1) {
            this.dispatchInfo.paymentDays = null;//自有车没有账期
            this.dispatchInfo.isBackhaul = false; //找回程货
            //自有车算费接口
          }
        } else {
          this.dispatchInfo.guidePrice = this.customerInfo.guidePrice;
        }
      }

      if (this.dispatchInfo.appointWay == 5) {
        this.dispatchInfo.guidePrice = this.customerInfo.guidePrice;
      }
      this.totalFeeChange();
    },
    // 更改中标价/承包价
    async totalFeeChange () {
      if (!isExist(this.dispatchInfo.totalFee)) {
        this.dispatchInfo.totalFee = 0;
      }
      this.scaleUpdate('CASH');
      this.scaleUpdate('VIRTUAL');
      this.scaleUpdate('OIL');
      this.scaleUpdate('ETC');
      this.scaleUpdate('ARRIVE_CASH');
      if ((this.dispatchInfo.appointWay === 3 && this.dispatchInfo.vehicleClass !== 1) || this.dispatchInfo.appointWay === 5) {
        // 获取最高中标价
        const res = await getAmountLimitCfgVal();
        if (isExist(res)) {
          this.dispatchInfo.maxAmount = (Number(res) / 100.0).toFixed(2);
        }
        if (isExist(this.dispatchInfo.maxAmount)) {
          if (this.dispatchInfo.totalFee > this.dispatchInfo.maxAmount && this.dispatchInfo.maxAmount >= 0) {
            this.$message({
              type: 'warning',
              message: `外调车运费不能超过${this.dispatchInfo.maxAmount}元`,
            });
          }
        }
      }
    },
    // 比例修改
    scaleUpdate (type) {
      let totalFee = this.dispatchInfo.totalFee;
      totalFee = isExist(totalFee) && !isNaN(totalFee) ? totalFee : 0;
      this.dispatchInfo.totalFee = Number(totalFee);

      if (type === 'CASH') {
        let preCashScale = this.dispatchInfo.preCashScale;
        preCashScale = isExist(preCashScale) && !isNaN(preCashScale) ? preCashScale : 0;

        this.dispatchInfo.preCashFee = Number(preCashScale) * totalFee / 100.0;
        if (isTwoBitDecimal(this.dispatchInfo.preCashFee)) {
          this.dispatchInfo.preCashFee = Math.round(this.dispatchInfo.preCashFee * 100) / 100;
          preCashScale = (this.dispatchInfo.preCashFee / totalFee) * 100;
          if (isTwoBitDecimal(preCashScale)) {
            preCashScale = Math.round(preCashScale * 100) / 100;
          }
        }
        preCashScale = Number(Number(preCashScale).toFixed(2));
        this.dispatchInfo.preCashScale = preCashScale;
      }
      if (type === 'VIRTUAL') {
        // 是否需要发票
        let preOilVirtualScale = this.dispatchInfo.preOilVirtualScale;
        preOilVirtualScale = isExist(preOilVirtualScale) && !isNaN(preOilVirtualScale) ? preOilVirtualScale : 0;
        let preOilVirtualFee = preOilVirtualScale * totalFee / 100;

        if (isTwoBitDecimal(preOilVirtualFee)) {
          preOilVirtualFee = Math.round(preOilVirtualFee * 100) / 100;
          preOilVirtualScale = preOilVirtualFee / totalFee * 100;
          if (isTwoBitDecimal(preOilVirtualScale)) {
            preOilVirtualScale = Math.round(preOilVirtualScale * 100) / 100;
          }
        }
        preOilVirtualFee = Number(Number(preOilVirtualFee).toFixed(2));
        preOilVirtualScale = Number(Number(preOilVirtualScale).toFixed(2));
        this.dispatchInfo.preOilVirtualFee = preOilVirtualFee;
        this.dispatchInfo.preOilVirtualScale = preOilVirtualScale;

        this.oilAccountTypeChange();
      }
      if (type === 'OIL') {
        let preOilScale = this.dispatchInfo.preOilScale;
        preOilScale = isExist(preOilScale) && !isNaN(preOilScale) ? preOilScale : 0;
        let preOilFee = preOilScale * totalFee / 100.0;
        if (isTwoBitDecimal(preOilFee)) {
          preOilFee = Math.round(preOilFee * 100) / 100;
          preOilScale = preOilFee / totalFee * 100;
          if (isTwoBitDecimal(preOilScale)) {
            preOilScale = Math.round(preOilScale * 100) / 100;
          }
        }
        preOilFee = Number(Number(preOilFee).toFixed(2));
        preOilScale = Number(Number(preOilScale).toFixed(2));
        this.dispatchInfo.preOilScale = preOilScale;
        this.dispatchInfo.preOilFee = preOilFee;
      }
      if (type === 'ETC') {
        let preEtcScale = this.dispatchInfo.preEtcScale;
        preEtcScale = isExist(preEtcScale) && !isNaN(preEtcScale) ? preEtcScale : 0;
        let preEtcFee = preEtcScale * totalFee / 100;
        if (isTwoBitDecimal(preEtcFee)) {
          preEtcFee = Math.round(preEtcFee * 100) / 100;
          preEtcScale = preEtcFee / totalFee * 100;
          if (isTwoBitDecimal(preEtcScale)) {
            preEtcScale = Math.round(preEtcScale * 100) / 100;
          }
        }
        preEtcFee = Number(Number(preEtcFee).toFixed(2));
        preEtcScale = Number(Number(preEtcScale).toFixed(2));
        this.dispatchInfo.preEtcScale = preEtcScale;
        this.dispatchInfo.preEtcFee = preEtcFee;
      }
      if (type === 'ARRIVE_CASH') {
        let arrivePaymentFeeScale = this.dispatchInfo.arrivePaymentFeeScale;
        arrivePaymentFeeScale = isExist(arrivePaymentFeeScale) && !isNaN(arrivePaymentFeeScale) ? arrivePaymentFeeScale : 0;
        let arrivePaymentFee = arrivePaymentFeeScale * totalFee / 100;
        if (isTwoBitDecimal(arrivePaymentFee)) {
          arrivePaymentFee = Math.round(arrivePaymentFee * 100) / 100;
          arrivePaymentFeeScale = arrivePaymentFee / totalFee * 100;
          if (isTwoBitDecimal(arrivePaymentFeeScale)) {
            arrivePaymentFeeScale = Math.round(arrivePaymentFeeScale * 100) / 100;
          }
        }
        arrivePaymentFee = Number(Number(arrivePaymentFee).toFixed(2));
        arrivePaymentFeeScale = Number(Number(arrivePaymentFeeScale).toFixed(2));
        this.dispatchInfo.arrivePaymentFeeScale = arrivePaymentFeeScale;
        this.dispatchInfo.arrivePaymentFee = arrivePaymentFee;
      }

      // 设置预付款和尾款
      this.setPreFeeAndFinalFee();
      // 设置尾款金额的现金
      this.setFinalCashFee();

      // if (this.dispatchInfo.oldInsuranceFee !== null && this.dispatchInfo.oldInsuranceFee >= 0) {
      //   this.dispatchInfo.finalCashFee = Number((this.dispatchInfo.finalFee - this.dispatchInfo.oldInsuranceFee).toFixed(2));
      // } else if (isExist(this.dispatchInfo.finalFee) && !isNaN(this.dispatchInfo.finalFee)) {
      //   this.setInsuranceFee();
      // }
      /* eslint-enable */
    },
    // 金额更改
    /* eslint-disable */
    feeUpdate (type) {
      let totalFee = this.dispatchInfo.totalFee;
      totalFee = isExist(totalFee) && !isNaN(totalFee) ? totalFee : 0;
      if (type === 'CASH') {
        let preCashFee = this.dispatchInfo.preCashFee;
        let preCashScale = this.dispatchInfo.preCashScale;
        preCashFee = isExist(preCashFee) && !isNaN(preCashFee) ? preCashFee : 0;
        if (totalFee !== 0) {
          preCashScale = preCashFee / totalFee * 100;
        } else {
          preCashScale = 0;
          preCashFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preCashScale)) {
          preCashScale = Math.round(preCashScale * 100) / 100;
        }

        this.dispatchInfo.preCashFee = parseFloat(preCashFee);
        this.dispatchInfo.preCashScale = parseFloat(preCashScale);
      }
      if (type === 'VIRTUAL') {
        let preOilVirtualFee = this.dispatchInfo.preOilVirtualFee;
        preOilVirtualFee = isExist(preOilVirtualFee) && !isNaN(preOilVirtualFee) ? preOilVirtualFee : 0;

        let preOilVirtualScale = this.dispatchInfo.preOilVirtualScale;
        if (totalFee !== 0) {
          preOilVirtualScale = this.dispatchInfo.preOilVirtualFee / totalFee * 100;
        } else {
          preOilVirtualScale = 0;
          preOilVirtualFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preOilVirtualScale)) {
          preOilVirtualScale = Math.round(preOilVirtualScale * 100) / 100;
        }
        this.dispatchInfo.preOilVirtualFee = parseFloat(preOilVirtualFee);
        this.dispatchInfo.preOilVirtualScale = parseFloat(preOilVirtualScale);

        this.oilAccountTypeChange();
      }
      if (type === 'OIL') {
        let preOilFee = this.dispatchInfo.preOilFee;
        preOilFee = isExist(preOilFee) && !isNaN(preOilFee) ? preOilFee : 0;
        let preOilScale = this.dispatchInfo.preOilScale;
        if (totalFee !== 0) {
          preOilScale = this.dispatchInfo.preOilFee / totalFee * 100;
        } else {
          preOilScale = 0;
          preOilFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preOilScale)) {
          preOilScale = Math.round(preOilScale * 100) / 100;
        }
        this.dispatchInfo.preOilFee = parseFloat(preOilFee);
        this.dispatchInfo.preOilScale = parseFloat(preOilScale);
      }
      if (type === 'ETC') {
        let preEtcFee = this.dispatchInfo.preEtcFee;
        preEtcFee = isExist(preEtcFee) && !isNaN(preEtcFee) ? preEtcFee : 0;
        let preEtcScale = this.dispatchInfo.preEtcScale;
        if (totalFee !== 0) {
          preEtcScale = preEtcFee / totalFee * 100;
        } else {
          preEtcScale = 0;
          preEtcFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preEtcScale)) {
          preEtcScale = Math.round(preEtcScale * 100) / 100;
        }
        this.dispatchInfo.preEtcFee = parseFloat(preEtcFee);
        this.dispatchInfo.preEtcScale = parseFloat(preEtcScale);
      }
      if (type === 'ARRIVE_CASH') {
        let arrivePaymentFee = this.dispatchInfo.arrivePaymentFee;
        arrivePaymentFee = isExist(arrivePaymentFee) && !isNaN(arrivePaymentFee) ? arrivePaymentFee : 0;
        let arrivePaymentFeeScale = this.dispatchInfo.arrivePaymentFeeScale;
        if (totalFee !== 0) {
          arrivePaymentFeeScale = arrivePaymentFee / totalFee * 100;
        } else {
          arrivePaymentFeeScale = 0;
          arrivePaymentFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(arrivePaymentFeeScale)) {
          arrivePaymentFeeScale = Math.round(arrivePaymentFeeScale * 100) / 100;
        }
        this.dispatchInfo.arrivePaymentFee = parseFloat(arrivePaymentFee);
        this.dispatchInfo.arrivePaymentFeeScale = parseFloat(arrivePaymentFeeScale);
      }

      // 设置预付款和尾款
      this.setPreFeeAndFinalFee();
      // 设置尾款金额的现金
      this.setFinalCashFee();

      // // 设置保费
      // if (this.dispatchInfo.oldInsuranceFee !== null && this.dispatchInfo.oldInsuranceFee >= 0) {
      //   this.dispatchInfo.finalCashFee = Number((this.dispatchInfo.finalFee - this.dispatchInfo.oldInsuranceFee).toFixed(2));
      // } else {
      //   this.setInsuranceFee();
      // }
    },
    // 设置尾款金额的现金
    setFinalCashFee () {
      this.dispatchInfo.finalCashFee = this.dispatchInfo.finalFee - this.dispatchInfo.insuranceFee;
    },
    /* eslint-enable */
    // 分配油来源变化
    oilAccountTypeChange () {
      if (this.dispatchInfo.preOilVirtualFee) {
        this.setFormAttrVal({ // 姓名
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['oilAccountType'],
        });
      } else {
        this.setFormAttrVal({ // 姓名
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['oilAccountType'],
        });
      }
      this.$emit('checkOilAccount');
    },
    // 设置预付款和尾款
    setPreFeeAndFinalFee () {
      /* eslint-disable */
      this.dispatchInfo.preTotalScale = Number((this.dispatchInfo.preCashScale - 0 + this.dispatchInfo.preOilVirtualScale - 0 + this.dispatchInfo.preOilScale - 0 + this.dispatchInfo.preEtcScale).toFixed(2));
      this.dispatchInfo.preTotalFee = this.dispatchInfo.preCashFee - 0 + this.dispatchInfo.preOilVirtualFee - 0 + this.dispatchInfo.preOilFee - 0 + this.dispatchInfo.preEtcFee;

      if (isTwoBitDecimal(this.dispatchInfo.preTotalFee)) {
        this.dispatchInfo.preTotalFee = Math.round(this.dispatchInfo.preTotalFee * 100) / 100;
      }

      // 尾款
      this.dispatchInfo.finalScale = ((100 - this.dispatchInfo.preTotalScale - this.dispatchInfo.arrivePaymentFeeScale)).toFixed(2);
      this.dispatchInfo.finalFee = Number((this.dispatchInfo.totalFee - this.dispatchInfo.preTotalFee - this.dispatchInfo.arrivePaymentFee).toFixed(2));
      /* eslint-enable */
    },
    // 设置保费
    setInsuranceFee () {
      let isContain = false;
      if (!this.feeList) {
        this.getVehicleClassLevel();
        return;
      }
      if (isExist(this.feeList) && isExist(this.dispatchInfo.totalFee)) {
        let totalFee = this.dispatchInfo.totalFee * 100;
        for (let i = 0; i < this.feeList.length; i++) {
          let obj = this.feeList[i];
          if (obj.maxFee !== -1) {
            if (((i === 0 && totalFee >= obj.minFee) || (totalFee > obj.minFee && i > 0)) && totalFee <= obj.maxFee) {
              this.dispatchInfo.insuranceFee = obj.insuranceFee / 100.0;
              this.dispatchInfo.finalCashFee = Number((this.dispatchInfo.finalFee - this.dispatchInfo.insuranceFee).toFixed(2));
              isContain = true;
            }
          } else {
            if (totalFee > obj.minFee) {
              this.dispatchInfo.insuranceFee = Number((obj.insuranceFee / 100.0).toFixed(2));
              this.dispatchInfo.finalCashFee = Number(Number(this.dispatchInfo.finalFee - this.dispatchInfo.insuranceFee).toFixed(2));
              isContain = true;
            }
          }
        }
      }

      if (!isContain) {
        this.dispatchInfo.insuranceFee = 0;
        this.dispatchInfo.finalCashFee = Number(Number(this.dispatchInfo.finalFee).toFixed(2));
      }
    },
    setCacheAndDetailData (data) {
      if (data.orderFeeDetail) {
        this.setFormValFromData(this.dispatchInfo, data.orderFeeDetail);
      }
      this.$refs.baseForm.setVal('taxPoint', data.taxPoint);
      this.$refs.baseForm.setVal('otherFee', data.otherFee);
      this.$refs.baseForm.setVal('showWagesFlg', data.showWagesFlg);
    },
    // 获取所以需要提交的参数
    sub () {
      if (this.$refs.baseForm) {
        const oilAccountType = this.$refs.baseForm.getVal('oilAccountType');
        this.dispatchInfo.oilAccountType = oilAccountType;
        const taxPoint = this.$refs.baseForm.getVal('taxPoint');
        this.dispatchInfo.taxPoint = taxPoint;
        const otherFee = this.$refs.baseForm.getVal('otherFee');
        this.dispatchInfo.otherFee = otherFee;
        const showWagesFlg = this.$refs.baseForm.getVal('showWagesFlg');
        this.dispatchInfo.showWagesFlg = showWagesFlg;
      }
      // 避免出现异常，删除外面已使用的参数
      delete this.dispatchInfo.vehicleClass;
      delete this.dispatchInfo.appointWay;
      delete this.dispatchInfo.isNeedBill;
      delete this.dispatchInfo.paymentWay;
      return this.dispatchInfo;
    },
    setPreOilFee () {
      // 不知道干嘛的
    },
  },
  watch: {
    isNeedBill (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dispatchInfo.isNeedBill = Number(newValue);
        this.setPreOilFee();
      }
    },
    paymentWay (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dispatchInfo.paymentWay = Number(newValue);
      }
    },
    appointWay (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dispatchInfo.appointWay = Number(newValue);
        if (this.dispatchInfo.appointWay === 5 || this.dispatchInfo.appointWay === 3) {
          this.setPreOilFee();
        }
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  created () {
    if (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2531 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
      this.setFormAttrVal({ // 姓名
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['taxPoint', 'otherFee'],
      });
    } else {
      this.setFormAttrVal({ // 姓名
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['taxPoint', 'otherFee'],
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.calc-box-container {
  display: flex;
  align-items: center;
  .text-box {
    font-size: 14px;
    border: 1px solid #ededed;
    border-radius: 2px;
    border-radius: 2px;
    padding: 10px;
    display: flex;
    &:nth-of-type(2) {
      margin-top: -1px;
    }
    &.f-dir-r {
      flex-direction: row;
    }
    &.f-dir-c {
      flex-direction: column;
    }
    &.jc-center {
      justify-content: center;
    }
    &.ai-center {
      align-items: center;
    }
    .label {
      color: #333333;
    }
    &:first-child {
      .value {
        color: #ff5046;
        .calc-chart-ipt {
          color: #ff5046;
        }
      }
    }
    .value {
      display: flex;
      .calc-chart-ipt {
        width: 38px;
        border: none;
        outline: none;
        &:only-child {
          width: 50px;
        }
      }
      .calc-chart-unit {
      }
    }
  }

  .calc-box-left {
    max-width: 96px;
    padding: 5px 10px;
    .text-box {
      .label {
        padding-bottom: 4px;
      }
      .value {
        .calc-chart-ipt {
          width: 100%;
          margin-right: 0;
          text-align: center;
        }
      }
    }
  }
  .calc-box-separate {
    width: 9px;
    height: 194px;
    margin-left: 26px;
    position: relative;
    border: 1px solid #ededed;
    border-right: none;
    &:before {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 7.5px solid transparent;
      border-right: 8px rgba(224, 233, 243, 1) solid;
      border-bottom: 7.5px solid transparent;
      top: 50%;
      left: -8px;
    }
    &:after {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 9px #fff solid;
      border-bottom: 6px solid transparent;
      top: 50%;
      left: -7px;
      z-index: 2;
    }
  }
  .calc-box-right {
    display: flex;
    flex-direction: column;
    .row-title {
      margin-bottom: 14px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      :first-child {
        width: 174px;
      }
      :nth-last-child(1) {
        width: 180px;
        text-align: right;
      }
      :nth-last-child(2) {
        width: 300px;
        text-align: center;
      }
    }
    .calc-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 24px;
      &:nth-of-type(2) {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 30px;
      }
      .row-label {
        margin-left: 12px;
        margin-right: 24px;
      }
      .row-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        .row-box {
          width: 120px;
          .text-box {
            &:only-child {
              height: 81px;
              box-sizing: border-box;
            }
            &:nth-of-type(2) {
              margin-top: -1px;
            }
            .label {
              width: 52px;
            }
          }
        }
        .row-symbol {
          font-size: 30px;
          color: #bcbbbb;
          margin: 0 22px;
        }
      }
    }
  }
}
</style>
